var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.linkJump
    ? _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value:
                _vm.$store.getters.loadingMap[_vm.$store.getters.currentPath],
              expression:
                "$store.getters.loadingMap[$store.getters.currentPath]",
            },
          ],
          staticStyle: { height: "430px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "span",
                {
                  staticStyle: { "font-weight": "600", "margin-right": "20px" },
                },
                [_vm._v(_vm._s(_vm.$t("panel.jump_set")))]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.linkJump.checked,
                    callback: function ($$v) {
                      _vm.$set(_vm.linkJump, "checked", $$v)
                    },
                    expression: "linkJump.checked",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.enable_jump")))]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c(
                "el-row",
                { staticClass: "preview" },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { height: "100%", "overflow-y": "auto" },
                      attrs: { span: 8 },
                    },
                    [
                      _c("el-row", { staticClass: "tree-head" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "30px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("panel.column_name")))]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "10px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("panel.enable_column")))]
                        ),
                      ]),
                      _c("el-tree", {
                        ref: "linkJumpInfoTree",
                        attrs: {
                          data: _vm.linkJumpInfoXArray,
                          "node-key": "sourceFieldId",
                          "highlight-current": "",
                          props: _vm.treeProp,
                        },
                        on: { "node-click": _vm.nodeClick },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var data = ref.data
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c("span", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "6px" },
                                        },
                                        [_vm._v(_vm._s(data.sourceFieldName))]
                                      ),
                                    ]),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "auth-span" },
                                            [
                                              _c("el-checkbox", {
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.sourceFieldCheckedChange(
                                                      data
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: data.checked,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      data,
                                                      "checked",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "data.checked",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          3635952714
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "preview-show", attrs: { span: 16 } },
                    [
                      _vm.linkJumpInfo
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-row",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    height: "30px",
                                  },
                                },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "margin-left": "20px" },
                                      attrs: { span: 4 },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("panel.link_type")) +
                                          "：\n            "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 10 } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "mini" },
                                          model: {
                                            value: _vm.linkJumpInfo.linkType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.linkJumpInfo,
                                                "linkType",
                                                $$v
                                              )
                                            },
                                            expression: "linkJumpInfo.linkType",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "outer" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("panel.link_outer")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "inner" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("panel.link_panel")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.linkJumpInfo.linkType === "inner"
                                    ? _c(
                                        "el-col",
                                        { attrs: { span: 9 } },
                                        [
                                          _c("treeselect", {
                                            staticStyle: {
                                              "margin-right": "10px",
                                            },
                                            attrs: {
                                              options: _vm.panelList,
                                              "disable-branch-nodes": true,
                                              normalizer: _vm.normalizer,
                                              placeholder: _vm.$t(
                                                "panel.select_jump_panel"
                                              ),
                                              "no-children-text": _vm.$t(
                                                "commons.treeselect.no_children_text"
                                              ),
                                              "no-options-text": _vm.$t(
                                                "commons.treeselect.no_options_text"
                                              ),
                                              "no-results-text": _vm.$t(
                                                "commons.treeselect.no_results_text"
                                              ),
                                            },
                                            on: {
                                              select: _vm.panelNodeClick,
                                              input: _vm.inputVal,
                                            },
                                            model: {
                                              value:
                                                _vm.linkJumpInfo.targetPanelId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.linkJumpInfo,
                                                  "targetPanelId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "linkJumpInfo.targetPanelId",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    height: "30px",
                                  },
                                },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { "margin-left": "20px" },
                                      attrs: { span: 4 },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("panel.open_model")) +
                                          "：\n            "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 10 } },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          attrs: { size: "mini" },
                                          model: {
                                            value: _vm.linkJumpInfo.jumpType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.linkJumpInfo,
                                                "jumpType",
                                                $$v
                                              )
                                            },
                                            expression: "linkJumpInfo.jumpType",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "_self" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("panel.now_window")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: "_blank" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("panel.new_window")
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.linkJumpInfo.linkType === "inner"
                                ? _c(
                                    "el-row",
                                    {
                                      staticClass: "top_border",
                                      staticStyle: { "margin-top": "5px" },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 11 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ellip" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("panel.link_view")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 11 } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ellip" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "panel.link_view_field"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            height: "180px",
                                            "overflow-y": "auto",
                                          },
                                        },
                                        _vm._l(
                                          _vm.linkJumpInfo.targetViewInfoList,
                                          function (targetViewInfo, index) {
                                            return _c(
                                              "el-row",
                                              { key: index },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 11 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "select-filed",
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder:
                                                                _vm.$t(
                                                                  "fu.search_bar.please_select"
                                                                ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.viewInfoOnChange(
                                                                  targetViewInfo
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                targetViewInfo.targetViewId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    targetViewInfo,
                                                                    "targetViewId",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "targetViewInfo.targetViewId",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.currentLinkPanelViewArray,
                                                            function (item) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: item.id,
                                                                  attrs: {
                                                                    label:
                                                                      item.name,
                                                                    value:
                                                                      item.id,
                                                                  },
                                                                },
                                                                [
                                                                  item.isPlugin
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              float:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "14px",
                                                                                  height:
                                                                                    "14px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    item.type !==
                                                                                    "buddle-map"
                                                                                      ? "/api/pluginCommon/staticInfo/" +
                                                                                        item.type +
                                                                                        "/svg"
                                                                                      : item.type,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              float:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "14px",
                                                                                  height:
                                                                                    "14px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    item.type,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          float:
                                                                            "left",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 11 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "select-filed",
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                              placeholder:
                                                                _vm.$t(
                                                                  "fu.search_bar.please_select"
                                                                ),
                                                            },
                                                            model: {
                                                              value:
                                                                targetViewInfo.targetFieldId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    targetViewInfo,
                                                                    "targetFieldId",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "targetViewInfo.targetFieldId",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .viewIdFieldArrayMap[
                                                              targetViewInfo
                                                                .targetViewId
                                                            ],
                                                            function (
                                                              viewField
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: viewField.id,
                                                                  attrs: {
                                                                    label:
                                                                      viewField.name,
                                                                    value:
                                                                      viewField.id,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          float:
                                                                            "left",
                                                                        },
                                                                    },
                                                                    [
                                                                      viewField.deType ===
                                                                      0
                                                                        ? _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticClass:
                                                                                "field-icon-text",
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    "field_text",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      viewField.deType ===
                                                                      1
                                                                        ? _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticClass:
                                                                                "field-icon-time",
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    "field_time",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      viewField.deType ===
                                                                        2 ||
                                                                      viewField.deType ===
                                                                        3
                                                                        ? _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticClass:
                                                                                "field-icon-value",
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    "field_value",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      viewField.deType ===
                                                                      5
                                                                        ? _c(
                                                                            "svg-icon",
                                                                            {
                                                                              staticClass:
                                                                                "field-icon-location",
                                                                              attrs:
                                                                                {
                                                                                  "icon-class":
                                                                                    "field_location",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          float:
                                                                            "left",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          viewField.name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 2 } },
                                                  [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("el-button", {
                                                          staticStyle: {
                                                            float: "left",
                                                          },
                                                          attrs: {
                                                            icon: "el-icon-delete",
                                                            type: "text",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteLinkJumpField(
                                                                index
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        { staticClass: "bottom" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  !_vm.linkJumpInfo
                                                    .targetPanelId,
                                                size: "mini",
                                                type: "success",
                                                icon: "el-icon-plus",
                                                round: "",
                                              },
                                              on: {
                                                click: _vm.addLinkJumpField,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("panel.add_jump_field")
                                                ) + "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "icon iconfont icon-edit slot-class",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.linkJumpInfo.linkType === "outer"
                                ? _c(
                                    "el-row",
                                    {
                                      staticStyle: {
                                        "border-top": "1px solid #E6E6E6",
                                        padding: "14px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            height: "230px",
                                            border: "1px solid #E6E6E6",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticStyle: { height: "100%" },
                                              attrs: { span: 18 },
                                            },
                                            [
                                              _c(
                                                "el-row",
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "panel.target_url"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "bottom",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "content",
                                                              },
                                                              slot: "content",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "panel.target_url_tips"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-info",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("codemirror", {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.codemirrorShow,
                                                        expression:
                                                          "codemirrorShow",
                                                      },
                                                    ],
                                                    ref: "myCm",
                                                    staticClass: "codemirror",
                                                    attrs: {
                                                      options: _vm.cmOption,
                                                    },
                                                    on: {
                                                      ready: _vm.onCmReady,
                                                      focus: _vm.onCmFocus,
                                                      input: _vm.onCmCodeChange,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.linkJumpInfo
                                                          .content,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.linkJumpInfo,
                                                          "content",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "linkJumpInfo.content",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            {
                                              staticStyle: {
                                                height: "100%",
                                                "border-left":
                                                  "1px solid #E6E6E6",
                                              },
                                              attrs: { span: 6 },
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                {
                                                  staticClass: "padding-lr",
                                                  staticStyle: {
                                                    height: "100%",
                                                  },
                                                  attrs: { span: 24 },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "panel.select_world"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            placement: "bottom",
                                                          },
                                                        },
                                                        [
                                                          _c("div", {
                                                            attrs: {
                                                              slot: "content",
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "chart.reference_field_tip"
                                                                )
                                                              ),
                                                            },
                                                            slot: "content",
                                                          }),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-info",
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("el-input", {
                                                    attrs: {
                                                      size: "mini",
                                                      placeholder:
                                                        _vm.$t(
                                                          "dataset.search"
                                                        ),
                                                      "prefix-icon":
                                                        "el-icon-search",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value: _vm.searchField,
                                                      callback: function ($$v) {
                                                        _vm.searchField = $$v
                                                      },
                                                      expression: "searchField",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-height",
                                                    },
                                                    [
                                                      _c("el-divider"),
                                                      _c(
                                                        "draggable",
                                                        {
                                                          staticClass:
                                                            "drag-list",
                                                          attrs: {
                                                            options: {
                                                              group: {
                                                                name: "drag",
                                                                pull: "clone",
                                                              },
                                                              sort: true,
                                                            },
                                                            animation: "300",
                                                            disabled: true,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.linkJumpInfoArray,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.linkJumpInfoArray =
                                                                $$v
                                                            },
                                                            expression:
                                                              "linkJumpInfoArray",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "transition-group",
                                                            _vm._l(
                                                              _vm.linkJumpInfoArray,
                                                              function (item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key: item.sourceFieldId,
                                                                    staticClass:
                                                                      "item-dimension",
                                                                    attrs: {
                                                                      title:
                                                                        item.sourceFieldName,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.insertFieldToCodeMirror(
                                                                            "[" +
                                                                              item.sourceFieldName +
                                                                              "]"
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    item.deExtractType ===
                                                                    0
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-text",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_text",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deExtractType ===
                                                                    1
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-time",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_time",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deExtractType ===
                                                                      2 ||
                                                                    item.deExtractType ===
                                                                      3
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-value",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_value",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    item.deExtractType ===
                                                                    5
                                                                      ? _c(
                                                                          "svg-icon",
                                                                          {
                                                                            staticClass:
                                                                              "field-icon-location",
                                                                            attrs:
                                                                              {
                                                                                "icon-class":
                                                                                  "field_location",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          item.sourceFieldName
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "el-row",
                            {
                              staticClass: "custom-position",
                              staticStyle: {
                                height: "100%",
                                "background-color": "var(--MainContentBG)",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("panel.select_dimension")) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "root-class" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("commons.cancel")) + "\n    ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("commons.confirm")) + "\n    ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }